import {getApi} from '../../modules/common/utils/api'

const api = getApi('default')

export const getAccountConfigurations = () => {
  return api.get(`/v3/account_configurations`)
}

export const upsertSettings = params => {
  return api.patch(`/v3/settings`, {account: params})
}
